import { Alert, Box, Snackbar } from "@mui/material";
import { Button } from "@mui/material";

export function ToastNotify({ alertState, setAlertState }) {
  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      open={alertState.open}
      autoHideDuration={10000}
      key={"top center"}
      onClose={() => setAlertState({ ...alertState, open: false })}
    >
      <Alert
        onClose={() => setAlertState({ ...alertState, open: false })}
        severity={alertState.severity}
      >
        {alertState.message}
      </Alert>
    </Snackbar>
  );
}

export function StyledButton({ children, ...props }) {
  return (
    <>
      <Button
        {...props}
        sx={{
          color: "#ffffff",
          background:
            "linear-gradient(90deg,#E2C811 30%, #5CA800 100%)",
          fontSize: "18px",
          boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
          textTransform: "capitalize",
          fontFamily: "Monroe-Regular",
          borderRadius: "0px",
          width: props.width,
          "&.Mui-disabled": {
            color: "#979EA7",
          },
          "&:hover": {
            background:
              "linear-gradient(90deg, #5CA800 30%, #E2C811 100%)",
          },
        }}
      >
        {children}
      </Button>
    </>
  );
}
export function StyledCurrencyButton({ children, ...props }) {
  return (
    <>
      <Box
        {...props}
        sx={{
          color: "green",
          background: "#F1F4F6",
          fontSize: "16px",
          fontWeight: "600",
          border: "2px solid #8dff22",
          textTransform: "capitalize",
          borderRadius: "0px",
          width: props.width,
          height: "40px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* <img
          width="25px"
          height="25px"
          src={children === "BUSD" ? busd : children === "BNB" ? bnb : usdt}
          alt=""
          style={{ marginRight: "10px" }}
        /> */}
        {children}
      </Box>
    </>
  );
}
export function StyledText({ children, ...props }) {
  return (
    <>
      <Box
        {...props}
        sx={{
          color: "#000000",
          fontSize: "18px",
          //   fontFamily: "Josefin Sans",
          fontWeight: "500",
          mr: props.mr,
        }}
      >
        {children}
      </Box>
    </>
  );
}
export function StyledTitle({ children, ...props }) {
  return (
    <>
      <Box
        {...props}
        sx={{
          color: "#000000",
          fontSize: "40px",
          //   fontFamily: "Josefin Sans",
          fontWeight: "700",
          mr: props.mr,
        }}
      >
        {children}
      </Box>
    </>
  );
}
